import MyComponent from '../../../component/userMaster/User';

const Users =()=>{

    return<MyComponent/>

};

export default Users;